<template>
  <transition name="fade2" mode="out-in">
    <div v-if="isActive" class="h-full"><slot /></div>
  </transition>
</template>
<script lang="ts">
import {
  defineComponent,
  getCurrentInstance,
  inject,
  onBeforeUnmount,
  onMounted,
  ref,
  Ref,
} from 'vue';
import gSteppersProvider, {
  initialGSteppersProvider,
} from '../config/gSteppersProvider';

export default defineComponent({
  name: 'GStepperItem',
  props: {
    value: {
      type: [String, Number],
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    dot: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const currentInstance = getCurrentInstance();
    const isActive: Ref<boolean> = ref(false);
    const wasActive: Ref<boolean> = ref(false);

    const { gStepperRegister } = inject(
      gSteppersProvider,
      initialGSteppersProvider
    );

    onMounted(() => {
      gStepperRegister.register(currentInstance?.proxy);
    });

    onBeforeUnmount(() => {
      gStepperRegister.unregister(currentInstance?.proxy);
    });

    return {
      isActive,
      wasActive,
    };
  },
});
</script>
<style lang="css" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.fade-leave-active {
  transform: opacity 1s;
  position: absolute !important;
  top: 0;
  width: 100%;
}

.fade2-enter-active,
.fade2-leave-active {
  transition: opacity 0.5s ease;
}

.fade2-enter-from,
.fade2-leave-to {
  opacity: 0;
}
</style>
